import { BASIC } from '@hotjar/webapp/domains/revenue/plan/feature-group';
import { FeatureGroupEnum as OrderedFeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';
import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';
import { useAccountTrialInfo } from '@hotjar/account';
import { PlanBadge } from '@hotjar/hotsauce';
import { useCurrentSite } from '@hotjar/site';

export interface ConditionalFeatureGroupBadgeProps {
  className?: string;
  kind: FeatureGroup;
  onClick?: () => void;
  size?: 's' | 'm' | 'l';
  isInTrial?: boolean;
}

export const ConditionalFeatureGroupBadge = (
  props: ConditionalFeatureGroupBadgeProps,
): JSX.Element | null => {
  const { kind: requiredFeatureGroup } = props;

  const { data: currentSite } = useCurrentSite();
  const currentSitePlan = currentSite?.plan as FeatureGroup;
  const trialInfo = useAccountTrialInfo();

  const requiredOrderedFeatureGroup = OrderedFeatureGroup[requiredFeatureGroup];
  const actualOrderedFeatureGroup = OrderedFeatureGroup[currentSitePlan];

  let shouldShow = true;

  /**
   * Show the badge to people:
   *  * whose current site is on Basic, or
   *  * who have an active trial or are eligible for one, or
   *  * whose plan is lower than the required one.
   *
   * Otherwise, hide it.
   */
  if (
    currentSitePlan !== BASIC &&
    !trialInfo?.activeOrEligible &&
    actualOrderedFeatureGroup >= requiredOrderedFeatureGroup
  ) {
    shouldShow = false;
  }

  return shouldShow ? <PlanBadge {...props} /> : null;
};
